export const IconTel = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="#CCE0FF" />
            <circle cx="14.78" cy="14.78" r="2.26" fill="white" />
            <circle cx="20.02" cy="14.78" r="2.26" fill="white" />
            <circle cx="25.22" cy="14.78" r="2.26" fill="white" />
            <circle cx="19.98" cy="14.78" r="2.26" transform="rotate(90 19.98 14.78)" fill="white" />
            <circle cx="19.98" cy="25.22" r="2.26" transform="rotate(90 19.98 25.22)" fill="white" />
            <circle cx="19.98" cy="20.02" r="2.26" transform="rotate(90 19.98 20.02)" fill="white" />
        </svg>
    )
}